'use strict';

/*
DOCUMENT ME
*/

define('modules/module.kbb',[
  'jquery',
  './module.static',
  'zipTools',
  'lib/util/zip',
  'storageUtil',
  'lib/util/tda.config'
], function (
  $,
  StaticModule,
  zipTools,
  zip,
  storageUtil,
  tdaConfig
) {
  var KBBModule = StaticModule.extend({
    events: function () {
      return Object.assign({}, StaticModule.prototype.events, {
        'click .module-cta-0': 'onViewClicked',
      });
    },

    staticData: {
      all: {
        image: {
          '1x1': '/assets/img/module/kbb/kbb-1.jpg',
          '2x1': '/assets/img/module/kbb/kbb-2.jpg',
          '3x1': '/assets/img/module/kbb/kbb-3.jpg'
        },
        subtext: 'Kelley Blue Book',
        subtextIcon: '/assets/img/module/kbb/award.svg',
      },
      en: {
        headline: 'What\'s Your Car Worth?',
        copy: {
          '1x1': '<p>Find out the KBB trade in value of your used car, minivan or truck towards a new Toyota.</p>',
          '2x1': '<p>Find the KBB car value of your trade in to use towards a new Toyota, from used minivans to trucks.</p>',
        },
        actions: [
          {
            title: 'View Your KBB Car Value',
            url: '/' + tdaConfig.site.context_url + '/trade-in-value/',
          }
        ]
      },
      es: {
        headline: '¿Cuánto vale tu vehículo?',
        copy: {
          '1x1': '<p>Mira el valor de intercambio de tu auto usado en KBB para tu nuevo vehículo Toyota.</p>'
        },
        actions: [
          {
            title: 'Ver valor del auto en KBB',
            url: '/' + tdaConfig.site.context_url + '/trade-in-value/',
          }
        ]
      }
    },

    getTemplateContext: function () {
      return $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
    },

    onViewClicked: function (e) {
      if (storageUtil.getTDA() === 'WWW') {
        // If we are on WWW, show the zip dialog
        e && e.preventDefault();
        zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), $(e.currentTarget).attr('href'));
      }
    },
  });

  return KBBModule;
});

